<template>
  <div class="animated fadeIn">
    <div class="display-3 font-3xl">
      <b-row>
        <b-col cols="2">Bore Hole</b-col>
        <b-col>
          <b-form-group :horizontal="true">
            <b-form-input
              type="text"
              v-model="identifier"
              placeholder="Bore Hole Name"
              invalid-feedback="Required"
              :state="!$v.identifier.$invalid"
            />
          </b-form-group>
        </b-col>
        <b-col v-if="bore_holes.length > 1" cols="2" class="pl-0">
          <b-button variant="danger" @click="removeBoreHole" block>
            <i class="fal fa-trash" /> Remove BH
          </b-button>
        </b-col>
      </b-row>
    </div>
    <div class="display-3 font-xl">
      <b-row class="mb-3">
        <b-col>Sample(s)</b-col>
      </b-row>
    </div>
    <div v-if="bore_hole && bore_hole.samples.length">
      <template v-for="(sample, index) in bore_hole.samples">
        <project-irrigation-hole-samples
          :key="index"
          :submissionId="submissionId"
          :boreHoleId="boreHoleId"
          :sampleId="sample.test_package_sample_id"
          :textureOptions="textureOptions"
          :horizonOptions="horizonOptions"
        />
      </template>
    </div>
    <b-row class="my-3" align-h="end">
      <b-col cols="2">
        <b-button @click.prevent="addSample" variant="success" block>
          <i class="fa fa-plus" /> Add Sample
        </b-button>
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import ProjectIrrigationHoleSamples from "./ProjectIrrigationHoleSamples";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate/src";
import { required } from "vuelidate/lib/validators";

export default {
  name: "ProjectIrrigationBoreHole",
  components: {
    ProjectIrrigationHoleSamples,
  },
  mixins: [validationMixin, ToastNotifications],
  props: {
    submissionId: {
      type: String,
      default: "",
    },
    boreHoleId: {
      type: String,
      default: "",
    },
    textureOptions: {
      type: Object,
      default: () => ({}),
    },
    horizonOptions: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      submission: "projectFormStepTwoSubmission",
    }),
    bore_holes() {
      return this.submission(this.submissionId).bore_holes;
    },
    bore_hole() {
      return this.bore_holes.find(
        (item) => item.bore_hole_id === this.boreHoleId
      );
    },
    identifier: {
      get() {
        return this.bore_hole.identifier;
      },
      set(value) {
        this.handleSubmissionUpdate({ value, field: "identifier" });
      },
    },
  },
  validations: {
    identifier: { required },
  },
  methods: {
    ...mapActions(["UPDATE_SUBMISSION"]),
    generateSample() {
      let lastSample;
      if (this.bore_hole.samples.length > 0) {
        lastSample = this.bore_hole.samples[this.bore_hole.samples.length - 1];
      }
      return {
        identifier: `Sample ${
          lastSample ? this.bore_hole.samples.length + 1 : 1
        }`,
        test_package_sample_id: this.$uuid.v4(),
        depth_start: lastSample ? lastSample.depth_end : 0,
        depth_end: lastSample ? lastSample.depth_end + 6 : 6,
      };
    },
    addSample() {
      const newSample = this.generateSample();
      this.bore_hole.samples.push(newSample);
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.bore_holes,
        name: "bore_holes",
      });
    },
    removeBoreHole() {
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.bore_holes.filter(
          (item) => item.bore_hole_id !== this.bore_hole.bore_hole_id
        ),
        name: "bore_holes",
      });
    },
    handleSubmissionUpdate({ value, field }) {
      this.bore_hole[field] = value;
      this.UPDATE_SUBMISSION({
        id: this.submissionId,
        value: this.bore_holes,
        name: "bore_holes",
      });
    },
  },
};
</script>
